module.exports = __webpack_public_path__ + "img/ring_g_i_1_0@2x.75bcaddf.png";